import { createStyles, Theme } from '@material-ui/core';

const styles = ({ colors, spacing }: Theme) => createStyles({
  root: {
    textAlign: 'right',
    marginRight: `-${spacing(2)}px`,

    '& button': {
      margin: 0,
    },
  },
  menuItem: {
  },
  menuItemDelete: {
    color: colors.pageElements.dropdownMenuOption.enabledError.name,
    '&:hover': {
      color: colors.pageElements.dropdownMenuOption.hoveredError.name,
      backgroundColor: colors.pageElements.dropdownMenuOption.hoveredError.background,
    },
  },
  menuList: {
    minWidth: spacing(25),
    maxWidth: spacing(60),
  },
  line: {
    margin: spacing(2),
    marginBottom: spacing(3),
    height: 2,
    backgroundColor: colors.layout.divider300,
    border: 'none',
  },
});

export default styles;
